import { TypedResource } from 'src/services/api-client/resource/base/TypedResource';
import User from 'src/entities/User';
import { AxiosPromise } from 'axios';
import { Data } from 'src/services/api-client/resource/base/Resource';
import { store } from 'src/store';
import { logout } from 'src/actions/authentication/login/Login.actions';

export default class UserResource extends TypedResource<User> {
  constructor( ) {
    super('/users/', User);
  }

  public updatePassword(id: number, data: Data): AxiosPromise {
    this.getHeaders();
    const url: string = this.route + id;

    return this.httpClient
      .put(url, data)
      .catch((errorResponse) => {
        if (errorResponse.response.data.message.includes('Unauthenticated')) {
          store.dispatch(logout());
        }
        throw errorResponse;
      });
  }

  public updateDefaultProfile(userId: number, id: string, personType: string): AxiosPromise {
    this.getHeaders();
    const url: string = this.route + userId + '/default-profile';
    const profileData = {
      id: id,
      personType: personType,
    };

    return this.httpClient
      .put(url, profileData)
      .catch((errorResponse) => {
        if (errorResponse.response.data.message.includes('Unauthenticated')) {
          store.dispatch(logout());
        }
        throw errorResponse;
      });
  }

}



// WEBPACK FOOTER //
// ./src/services/api-client/resource/UserResource.tsx